import { axios } from '@Root/API'

export const configureExportColumns = (payload, params) => {
	return axios.post('export/moodle-contacts', payload, { params })
}
